import ConfirmTransferRedeemableScreen from "@screens/experiences/ConfirmTransferRedeemableScreen";
import ExperiencesHistoryScreen from "@screens/experiences/ExperiencesHistoryScreen";
import ExperiencesMainScreen from "@screens/experiences/ExperiencesMainScreen";
import RedeemableScreen from "@screens/experiences/RedeemableScreen";
import SectionRedeemableScreen from "@screens/experiences/SectionRedeemableScreen";
import TransferRedeemableScreen from "@screens/experiences/TransferRedeemableScreen";
import ScannerExperiencesScreen from "@screens/scanner/ScannerExperiencesScreen";
import { ExperienceNavigator } from "./ExperienceNavigator";
import NavigationInstantiator from "./helpers/NavigationInstantiator";
import { NotificationsNavigator } from "./NotificationsNavigator";
import { ProfileNavigator } from "./ProfileNavigator";

const ExperiencesNavigatorScreens = {
    ExperiencesMain: {
        routeName: "ExperiencesMain",
        title: "Experiences",
        component: ExperiencesMainScreen,
    },
    ExperiencesHistory: {
        routeName: "ExperiencesHistory",
        title: "History",
        component: ExperiencesHistoryScreen,
    },
    Experience: {
        routeName: "Experience",
        title: "Experience",
        component: ExperienceNavigator,
    },
    Profile: {
        routeName: "Profile",
        title: "Profile",
        component: ProfileNavigator,
    },
    Notifications: {
        routeName: "Notifications",
        title: "Notifications",
        component: NotificationsNavigator,
    },
    ScannerExperiences: {
        routeName: "ScannerExperiences",
        title: "Scanner Experiences",
        component: ScannerExperiencesScreen,
    },
};

const ExperiencesNavigator = NavigationInstantiator(ExperiencesNavigatorScreens);

export { ExperiencesNavigator, ExperiencesNavigatorScreens };
